import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useCalendarGlassStyles } from './calendarGlassStyles';

/** Shows which emails this day's rider has already been sent to. */
export function RiderShareBanner({ shares = [], theme, isDarkMode = true }) {
  const glassStyles = useCalendarGlassStyles(theme, isDarkMode);
  const styles = useMemo(() => createStyles(theme, glassStyles), [theme, glassStyles]);

  const emails = useMemo(() => {
    const seen = new Set();
    const list = [];
    (shares || []).forEach((entry) => {
      const email = String(entry?.email || '').trim().toLowerCase();
      if (!email || seen.has(email)) return;
      seen.add(email);
      list.push(email);
    });
    return list;
  }, [shares]);

  if (!emails.length) return null;

  return (
    <View style={styles.banner}>
      <Ionicons name="mail-open-outline" size={16} color={theme.brand.primary} />
      <View style={styles.copy}>
        <Text style={styles.title}>Shared with</Text>
        <Text style={styles.emails} numberOfLines={3}>
          {emails.join(', ')}
        </Text>
      </View>
    </View>
  );
}

function createStyles(theme, glassStyles) {
  return StyleSheet.create({
    banner: {
      ...glassStyles.cardInset,
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 8,
      borderColor: `${theme.brand.primary}44`,
      backgroundColor: `${theme.brand.primary}10`,
    },
    copy: { flex: 1, minWidth: 0, gap: 2 },
    title: {
      fontSize: 10,
      fontWeight: '800',
      color: theme.brand.primary,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    emails: {
      fontSize: 12,
      lineHeight: 16,
      color: theme.text.primary,
    },
  });
}

export default RiderShareBanner;
